var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuturesAccount = function SvgFuturesAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 4.492c0-.55.33-.742.469-.742h8.747c.137 0 .468.192.468.742v11.675H4.22c-.138 0-.469-.192-.469-.741zM4.22 2.5C3.145 2.5 2.5 3.527 2.5 4.492v10.934c0 .965.645 1.991 1.719 1.991h11.818a2.29 2.29 0 0 0 2.292-2.291v-4.074c0-.605-.437-1.263-1.172-1.263h-2.473V4.492c0-.965-.644-1.992-1.718-1.992zm10.465 8.54v5.127h1.353c.576 0 1.042-.466 1.042-1.041v-4.087z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.954 7.063c0-.275-.225-.5-.5-.5h-3.15c-.275 0-.5.225-.5.5s.225.5.5.5h1.925l-3.1 2.775c-.2.183-.217.5-.034.7.184.2.5.216.7.033l3.167-2.85v2.125c0 .275.225.5.5.5s.5-.225.5-.5V7.063z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.209 13.05a.625.625 0 1 0 0 1.25h4.512a.625.625 0 0 0 0-1.25z"
  })));
};
export default SvgFuturesAccount;